import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const ChevronLeft = (props: any) => {
  return <ChevronLeftIcon {...props} />;
};

export default ChevronLeft;
